import { ScreenOrientation } from '@gongxigames/framework/core';
import {ScrollToFullscreen} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/ScrollToFullscreen';
import {SHOWN_SCROLL_CONTAINER_STYLE_CLASS} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/createScrollContainer';

const MinimumMajorVersion = 16;
const MinimumMinorVersion = 1;

export class ScrollToFullscreenIOS161 extends ScrollToFullscreen {
    public static matchVersion(iOSVersion = ''): boolean {
        const [major = 0, minor = 0]: number[] = iOSVersion.split('_').map(Number);

        return major >= MinimumMajorVersion && minor >= MinimumMinorVersion;
    }

    constructor() {
        super();

        this._body.appendChild(this._scrollContainer);
        this._scrollContainer
            .removeEventListener('touchmove', this._touchMoveOnScrollContainerListener, {capture: true});

        this.setInvisible();
    }

    protected setVisible(_currentOrientation: ScreenOrientation): void {
        this._scrollContainer.style.visibility = 'visible';

        this._body.classList.add(SHOWN_SCROLL_CONTAINER_STYLE_CLASS);
        this._isVisibleScrollContainer = true;
    }

    protected setInvisible(): void {
        this._scrollContainer.style.visibility = 'hidden';

        this._body.classList.remove(SHOWN_SCROLL_CONTAINER_STYLE_CLASS);

        window.scrollBy(0, 0);
        this._isVisibleScrollContainer = false;
    }
}
